import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    callNetPosition: true,
    refreshGlobalCalled: false,
    isPollingEnable: false,
    pollingUpdateFireBase: false,
    isSolaceEnabled: false,
    disableChartsIframe: true,
    isOrderSetting: false,
    isPredefined: false,
};
export const commonReducer = createSlice({
    name: "common-reducer",
    initialState: initialState,
    reducers: {
        refreshNetPosition: (state, action) => {
            state.callNetPosition = action.payload;
        },
        setRefreshGlobalCalled: (state, action) => {
            state.refreshGlobalCalled = action.payload;
        },
        isPollingEnable: (state, action) => {
            state.isPollingEnable = action.payload;
        },
        setPollingUpdateFireBase: (state, action) => {
            state.pollingUpdateFireBase = action.payload;
        },
        setisSolaceEnabled: (state, action) => {
            state.isSolaceEnabled = action.payload;
        },
        setIsChartsIframeEnabled: (state, action) => {
            state.disableChartsIframe = action.payload;
        },
        setIsOderSetting: (state, action) => {
            state.isOrderSetting = action.payload;
        },
        setIsPredefined: (state, action) => {
            state.isPredefined = action.payload;
        },
    },
});
export const { refreshNetPosition, setRefreshGlobalCalled, isPollingEnable, setPollingUpdateFireBase, setisSolaceEnabled, setIsChartsIframeEnabled, setIsOderSetting, setIsPredefined, } = commonReducer.actions;
export default commonReducer.reducer;
